export const releaseInfo = {
    version: '8dc55fc8',
}
